import { find } from "rxjs";
import {
    gettingCountry,
    gettingCounty,
    gettingCustomer,
    gettingCustomerDetailsById,
    gettingState,
    gettingWell,
    gettingWellDetailsById,
    setCaseName,
    setContact,
    setCountry,
    setCountryList,
    setCounty,
    setCountyList,
    setCountyNameList,
    setCountyOther,
    setCustomer,
    setCustomerList,
    setEqupiment,
    setfilteredCountryList,
    setFormation,
    setProjectName,
    setReprestative,
    setState,
    setStateList,
    setunitMeasurement,
    setWell,
    setWellApiNo,
    setWellList,
    resetProjectState,
    setCaseDescription,
    setDuplicateCountyList,
    setTemplate,
    setWellID,
    setCustomerID,
    getAccountManagerList,
    setAccountManagerList,
    setAccountManager,
    setCustomerSearch,
    setWellSearch,
    setLiftOption,
    setJetliftProjectID,
} from "../store/dashboard/CreateProjectSlice";
import { useAppDispatch, useAppSelector } from "../store/hooks/StoreHooks";
import {
    CustomerDetailsPayload,
    WellDetailsPayload,
} from "../store/model/calculations/calculation";
import { designType, jetliftID } from "../store/model/jetlift/jetlift";

const useCreateProjectFacade = () => {
    const dispatch = useAppDispatch();

    const { countryList, countyList, stateList } = useAppSelector((state) => state?.createProject);

    const updateProjectName = (payload: string) => {
        return dispatch(setProjectName(payload));
    };

    const updateCaseName = (payload: string) => {
        return dispatch(setCaseName(payload));
    };

    const updateReprestative = (payload: string) => {
        return dispatch(setReprestative(payload));
    };

    const updateFormation = (payload: string) => {
        return dispatch(setFormation(payload));
    };

    const updateContact = (payload: string) => {
        return dispatch(setContact(payload));
    };

    const updateWell = (payload: number | string) => {
        return dispatch(setWell(payload));
    };

    const updateWellID = (payload: number | string | null) => {
        return dispatch(setWellID(payload));
    };

    const updateWellList = (payload: any) => {
        return dispatch(setWellList(payload));
    };
    const updateCustomerList = (payload: any) => {
        return dispatch(setCustomerList(payload));
    };
    const updateCountry = (payload: string | number) => {
        return dispatch(setCountry(payload));
    };

    const updateTemplate = (payload: string) => {
        return dispatch(setTemplate(payload));
    };

    const updateStateList = (payload: any) => {
        return dispatch(setStateList(payload));
    };

    const updateState = (payload: string) => {
        return dispatch(setState(payload))
    }

    const updateCounty = (payload: string | number) => {
        return dispatch(setCounty(payload));
    };

    const updateCountyList = (payload: any) => {
        return dispatch(setCountyList(payload));
    };

    const updateOtherCounty = (payload: any) => {
        return dispatch(setCountyOther(payload));
    }

    const updateCustomer = (payload: string | number) => {
        return dispatch(setCustomer(payload));
    };

    const updateCustomerID = (payload: string | number | null) => {
        return dispatch(setCustomerID(payload));
    };

    const loadWell = async (payload: WellDetailsPayload) => {
        return await dispatch(gettingWell(payload));
    };
    const loadCountry = async () => {
        return await dispatch(gettingCountry());
    };

    const loadCounty = async (stateID: string) => {
        return await dispatch(gettingCounty({ stateID }));
    };

    const loadState = async (State: string) => {
        return await dispatch(gettingState({ State }));
    };

    const loadCustomer = async (payload: CustomerDetailsPayload) => {
        return await dispatch(gettingCustomer(payload));
    };

    const loadCustomerByDetails = async (Id: number) => {
        return await dispatch(gettingCustomerDetailsById(Id)).then(async (reposnse: any) => {
            if (reposnse.payload) {
                updateContact(reposnse?.payload?.value?.contactName ?? "");
            }
        });
    };

    const updateWellApiNo = (payload: string) => {
        return dispatch(setWellApiNo(payload));
    };
    const updateCountryList = (payload: string | number) => {
        return dispatch(setCountryList(payload));
    };

    const updateCountyNameList = (payload: string) => {
        return dispatch(setCountyNameList(payload));
    };

    const updatefilteredCountryList = (payload: string) => {
        return dispatch(setfilteredCountryList(payload));
    };

    const updateEqupiment = (payload: number) => {
        return dispatch(setEqupiment(payload));
    };

    const loadWellDetailsById = async (name: string, country: string, state: string, county: string, apino: string, option?: any) => {
        updateWell(name);
        updateWellApiNo(apino);
        if (option?.operator) {
            updateCustomer(option.operator);
        }
        if (option?.operatorId != null && option?.operatorId !== "") {
            updateCustomerID(option.operatorId);
        }
        if (option?.operatorContact) {
            updateContact(option.operatorContact);
        }
        updateFormation(option?.formation ?? "");
        const findCountry = countryList.find(
            (item: any) =>
                item.label === country
        );
        if (findCountry) {
            updateCountry(findCountry?.value);
            await loadState(findCountry?.value);
        }
        if (state) {
            await loadState(findCountry?.value).then(async (stateResponse) => {
                if (stateResponse) {
                    const findState = stateResponse?.payload.find(
                        (itemm: any) =>
                            itemm.stateName === state
                    );
                    if (findState)
                        updateState(findState?.stateID);
                        await loadCounty(findState?.stateID).then(async (countyResponse) => {
                            const findcounty = Object.entries(countyResponse?.payload).map(([Key, value]) => ({
                                label: Key,
                                value: value,
                            }));
                            const ConnCounty = findcounty?.find(
                                (item: any) => item?.label?.toLowerCase() === county?.toLowerCase()
                            );
                            if (ConnCounty) {
                                updateCounty(ConnCounty?.value as string | number);
                            }
                        });
                }
            });
        }
        else if (county) {
            const transformedData = Object.entries({}).map(([key, value]) => ({
                label: key,
                value: value
            }));
            transformedData.unshift({
                value: "",
                label: county,
            });
            updateCountyList(transformedData)
            updateCounty(transformedData[0]?.label)
        }
    };

    const UpdateUnitMeasurement = (payload: number) => {
        return dispatch(setunitMeasurement(payload));
    };

    const UpdateCaseDescription = (payload: string) => {
        return dispatch(setCaseDescription(payload));
    };
    const resetCreateForm = () => {
        return dispatch(resetProjectState());
    };
    const updateDuplicateCountyList = (payload: any) => {
        return dispatch(setDuplicateCountyList(payload));
    };
    const loadAccountManager = () => {
        return dispatch(getAccountManagerList());
    };
    const updateAccountManagerList = (payload: string) => {
        return dispatch(setAccountManagerList(payload));
    };
    const updateAccountManager = (payload: string) => {
        return dispatch(setAccountManager(payload));
    };
    const updateCustomerSearch = (payload: string) => {
        return dispatch(setCustomerSearch(payload));
    };

    const updateWellSearch = (payload: string) => {
        return dispatch(setWellSearch(payload));
    };

    const updateLiftOption = (payload: designType) => {
        return dispatch(setLiftOption(payload));
    };

    const updateClearWell = () => {
        updateWell("");
        updateWellSearch("");
        updateWellID(null);
        updateWellApiNo("");
        updateCounty("");
        updateCountry("");
        updateState("");
        updateCountyList([]);
        updateStateList([]);
        updateOtherCounty("");
    };

    const handleClearCustomer = () => {
        updateCustomer("");
        updateCustomerID(null);
        updateContact("");
        updateCustomerSearch("");
    };

    const updateJetliftProjectID = (payload: jetliftID) => {
        return dispatch(setJetliftProjectID(payload));
    };

    return {
        updateProjectName,
        updateCaseName,
        updateReprestative,
        updateFormation,
        updateContact,
        updateWell,
        updateCountry,
        updateStateList,
        updateState,
        updateCounty,
        updateCustomer,
        loadWell,
        loadCountry,
        loadCounty,
        loadState,
        loadCustomer,
        loadCustomerByDetails,
        loadWellDetailsById,
        updateCountryList,
        updateCountyNameList,
        updateCountyList,
        updateOtherCounty,
        updateWellApiNo,
        updateWellList,
        updateEqupiment,
        updateCustomerList,
        UpdateUnitMeasurement,
        resetCreateForm,
        UpdateCaseDescription,
        updateDuplicateCountyList,
        updateTemplate,
        updateWellID,
        updateCustomerID,
        updateAccountManagerList,
        loadAccountManager,
        updateAccountManager,
        updateCustomerSearch,
        updateWellSearch,
        updateClearWell,
        handleClearCustomer,
        updateLiftOption,
        updateJetliftProjectID,
    };
};

export default useCreateProjectFacade;
